<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <TextEditor
          title="URL"
          v-model="value.url"
          :table="table"
          :component="component"
          :containers="containers"
        />
      </v-col>
      <v-col>
        <v-select
          label="Target"
          filled
          hide-details
          :items="['_blank', '_self', '_top']"
          v-model="value.target"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextEditor from "../shared/TextEditor.vue";

export default {
  name: "OpenURLDesigner",

  components: { TextEditor },

  props: ["value", "table", "component", "containers"],
};
</script>
